import React from 'react';
import TrackLine from '../TrackLine';
import { logInfo } from '../../../../../utils/logger';

export const RouteLayer = ({ routes = [], visibilityState = {}, map, settings }) => {
  // Filter routes based on visibility state
  const visibleRoutes = routes.filter(route => {
    return !route.deleted && // Not deleted
           visibilityState.routes?.[route.id] !== false; // Route is visible
  });

  const lineWidth = settings?.routeLineWidth || 4;
  const opacity = settings?.routeOpacity || 1;

  logInfo(`Rendering ${visibleRoutes.length} visible routes`);

  return (
    <>
      {visibleRoutes.map(route => (
        <TrackLine
          key={route.id}
          points={route.trackPoints}
          type="recorded"
          color={route.color}
          strokeWidth={lineWidth}
          opacity={opacity}
          map={map}
        />
      ))}
    </>
  );
};

export default RouteLayer;